<div class="explore">
	<div class="title-bar">
		<div class="title">
			{{ title }}
		</div>
		<div class="container">
			@for(option of options; track option.type){
			<div class="item" (click)="setVisualizationType(option.type)">
				<div [ngClass]="{ selected: isSelected(option.type) }">
					{{ option.label }}
				</div>
				<div
					class="indicator"
					[hidden]="!isSelected(option.type)"
				></div>
			</div>
			}
		</div>
	</div>
	@if(showTooltip){
	<div class="tooltip" [ngStyle]="tooltipStyle">
		<div class="name">{{ loc.name }}</div>
		<div class="city">{{ loc.city }}</div>
		@if(loc.counts?.length > 1) {
		<div class="counts">
			@for(sector of tooltipSectors; track sector.name) {
			<div class="sector">
				<div class="label">
					<div class="dot" [ngStyle]="sector.style"></div>
					{{ sector.name }}
				</div>
				<div class="value">
					{{ sector.value }}
				</div>
			</div>
			}
		</div>
		}
	</div>
	}
	<div class="content">
		@if(sectorsEnabled){
		<div class="sector" [hidden]="!isSector">
			<sector-map [summary]="summary"></sector-map>
		</div>
		}@if(tagsEnabled){
		<div class="tags" [hidden]="!isTags">
			<tag-cloud [summary]="summary"></tag-cloud>
		</div>
		} @if(geoEnabled && renderedGeo) {
		<div class="geography" [hidden]="!isGeography">
			<geo-visualizer
				[locationInfos]="locationInfos"
				[tooltipHandler]="tooltipHandler"
			></geo-visualizer>
		</div>
		} @if(inAssetMode) { @if(isDevelopmentStage) {
		<div class="developmentStage">
			<stacked-bar-chart
				[data]="taStageCounts"
				[colorMap]="getColorFromDevStage"
				[title]="TherapeuticAreaTitle"
				[xAxisLabel]="DevelopmentStageLabel"
				[yAxisLabel]="TherapeuticAreaLabel"
				[legendLabels]="developmentStages"
				[itemLabel]="assetsLabel"
				lowestYGroup="Not Classified / Other"
				(onCategorySelected)="selectTAAndDevStage($event)"
			></stacked-bar-chart>
		</div>
		} @else {
		<div class="focusArea">
			<stacked-bar-chart
				[data]="focusAreaCounts"
				[colorMap]="getColorFromDevStage"
				[title]="FocusAreaTitle"
				[xAxisLabel]="DevelopmentStageLabel"
				[yAxisLabel]="FocusAreaLabel"
				[legendLabels]="developmentStages"
				[itemLabel]="assetsLabel"
				(onCategorySelected)="selectFocusAndDevStage($event)"
			></stacked-bar-chart>
		</div>
		}}
		<div
			class="geo-footer"
			[ngStyle]="{
				maxWidth: this.themeSettings.map.maxWidth,
				width: '90vw',
			}"
		>
			@if(showVirtualLoc) {
			<div class="virtual-annulus">
				<location-indicator
					class="virtual-indicator"
					[locationMarker]="virtualLocationInfo"
					[summary]="summary"
					[tooltipHandler]="tooltipHandler"
					[invertLabel]="true"
				>
				</location-indicator>
				<div class="label">
					{{ Loc(LocalizedTextIds.CompanyDetailsVirtual) }}
				</div>
			</div>
			}

			<!-- Only the Geography (visualizationType === 'Geography') company viz. has a legend. -->
			@if(isGeography) {
			<div class="legend">
				<div class="container">
					@for(entry of sectorAndStyles; track entry.sector) {
					<div class="item">
						<div class="dot"></div>
						<div class="dot" [ngStyle]="entry.style"></div>
						{{ entry.sector }}
					</div>
					}
				</div>
			</div>
			}
		</div>
	</div>
</div>
